import { Button, IconCompareAdd16 } from '@cian/ui-kit';
import * as React from 'react';

interface IComparisonButtonProps {
  onClick(): void;
  disabled: boolean;
}

export const ComparisonButton: React.FC<IComparisonButtonProps> = ({ onClick, disabled }) => {
  return (
    <Button
      size="XS"
      theme="fill_secondary"
      data-mark="ComparisonControl"
      onClick={onClick}
      beforeIcon={<IconCompareAdd16 color={disabled ? 'gray60_100' : 'primary_100'} />}
      disabled={disabled}
    />
  );
};
